import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import api from '../utils/api';

export default function ChangePassword() {
  const [form, setForm]     = useState({ current_password:'', new_password:'', confirm:'' });
  const [error, setError]   = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async e => {
    e.preventDefault();
    if (form.new_password !== form.confirm) { setError('New passwords do not match'); return; }
    setLoading(true); setError('');
    try {
      await api.post('/auth/change-password', form);
      setSuccess('Password changed successfully! Redirecting...');
      setTimeout(() => navigate('/'), 2000);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to change password');
    } finally { setLoading(false); }
  };

  return (
    <Layout title="Change Password">
      <div style={{maxWidth:400,margin:'0 auto'}}>
        <div className="card">
          {error   && <div className="alert alert-error">{error}</div>}
          {success && <div className="alert alert-success">{success}</div>}
          <form onSubmit={handleSubmit}>
            <div style={{display:'flex',flexDirection:'column',gap:14}}>
              {[
                {key:'current_password',label:'Current Password'},
                {key:'new_password',    label:'New Password'},
                {key:'confirm',         label:'Confirm New Password'},
              ].map(f => (
                <div className="field" key={f.key}>
                  <label>{f.label} <span className="req">*</span></label>
                  <input type="password" value={form[f.key]}
                    onChange={e => setForm({...form,[f.key]:e.target.value})} required minLength={6} />
                </div>
              ))}
              <button type="submit" className="btn btn-primary" disabled={loading}>
                {loading ? <><i className="fa-solid fa-spinner fa-spin"></i> Updating...</> : <><i className="fa-solid fa-key"></i> Change Password</>}
              </button>
            </div>
          </form>
        </div>
      </div>
    </Layout>
  );
}
